import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
export var CalloutCard = function CalloutCard(props) {
  var callout = props.callout,
      calloutNote = props.calloutNote,
      ctaCopy = props.ctaCopy,
      details = props.details,
      extraClass = props.extraClass,
      handleClick = props.onClick,
      selected = props.selected,
      tag = props.tag;
  return React.createElement("div", {
    className: classNames('plan', {
      'plan--selected': selected
    }, extraClass),
    onClick: handleClick
  }, React.createElement("div", {
    className: "plan__choice md-hidden"
  }, React.createElement("input", {
    type: "radio",
    checked: selected,
    readOnly: true
  })), React.createElement("div", {
    className: "plan__content"
  }, tag && React.createElement("div", {
    className: "plan__tag"
  }, React.createElement("span", null, tag)), React.createElement("div", {
    className: "plan__top"
  }, React.createElement("div", {
    className: "plan__callout"
  }, callout), calloutNote && React.createElement("p", {
    className: "plan__note"
  }, calloutNote), details && React.createElement("div", {
    className: "plan__details"
  }, details)), React.createElement("div", {
    className: "md-block hidden"
  }, React.createElement("button", {
    className: "bt bt--primary bt--lg bt--width-full"
  }, ctaCopy)), React.createElement("div", {
    className: "md-block hidden"
  }, props.children)));
};
CalloutCard.propTypes = {
  callout: PropTypes.node.isRequired,
  calloutNote: PropTypes.node,
  children: PropTypes.node,
  ctaCopy: PropTypes.node.isRequired,
  extraClass: PropTypes.string,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  details: PropTypes.node,
  tag: PropTypes.node
};